// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xBaseTheme } from "@sc/XDL/types";
import color from "@sc/XDL/Utilities/color";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            size: 14,
            ellipsis: true,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 22px;
                max-width: 100ch;
                ${IconWrapper}, ${IconWrapper} svg {
                    color: ${color("common.ui4")};
                    width: 8px;
                    height: 18px;
                }
            `,
        },
        css: css`
            flex-wrap: wrap;
            margin-bottom: 20px;
            margin-top: 12px;
            row-gap: 4px;
            ${StyledButton} {
                position: relative;
                overflow: hidden;
            }
            ${StyledButton} > ${TypographyStyle} {
                color: ${color("text.link")};
            }

            & > ${TypographyStyle} {
                font-size: 14px;
                font-weight: normal;
                letter-spacing: 0;
                line-height: 22px;
                &:last-child {
                    font-weight: bold;
                }
            }
            @media print {
                display: none;
            }
        `,
    },
} as xBaseTheme["breadcrumbs"];
